import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppComponent } from './app.component';
import { AppStateModule } from '@core/state/app/app-state.module';
import { AuthInterceptor } from '@core/data/http/auth-interceptor';
import { WINDOW_PROVIDERS } from '@vendor/window/window.component';
import { HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { ENV_PROVIDERS } from './environment/environment';
import { AppService } from './app.service';
import { TranslateModule } from '@ngx-translate/core';
import { TranslateLoader } from '@ngx-translate/core';
import { TranslateLoaderFactory } from '@core/translation/translate-session-loader';
import { AppRouterStoreModule } from '@core/router/app-router-store.module';
import { NumeralModule } from '@vendor/numeral/numeral.module';
import { CoreModule } from '@core/core.module';
import { WindowModule } from '@vendor/window/window.module';
import { appRoutes } from './app.routes';
import { environment } from '@environments/environment';
import { LOTTIE_PROVIDER } from '@vendor/lottie/lottie-provider';
import { MobileBlockerComponent } from '@shell/ui/mobile-blocker/mobile-blocker.component';
import { NavigationMenuComponent } from '@shell/ui/navigation-menu/navigation-menu.component';
import { ProfileMenuComponent } from '@shell/ui/profile-menu/profile-menu.component';
import { ContextBarModule } from '@shell/ui/context-bar/context-bar.module';
import { ContextBarDirectiveModule } from '@shared/directives/context-bar/context-bar.directive.module';
import { EmptyComponent } from './components/empty/empty.component';
import { GoComponent } from './features/go/go.component';
import { AllowedForAppFlavourDirective } from '@shared/directives/app/allowed-for-app-flavour.directive';
import { AppFlavourClassDirective } from '@shared/directives/app/app-flavour-class.directive';
import { CLIENT_CONFIG_INITIALIZER_PROVIDER } from '@core/services/client-config-initializer';

// Application wide providers
const APP_PROVIDERS = [
  WINDOW_PROVIDERS,
  { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
];

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    appRoutes,
    BrowserModule,
    BrowserAnimationsModule,
    CoreModule.forRoot(),
    WindowModule,
    TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader, useFactory: TranslateLoaderFactory, deps: [HttpClient]
      }
    }),
    NumeralModule,
    AppRouterStoreModule,

    /**
         * Store devtools instrument the store retaining past versions of state
         * and recalculating new states. This enables powerful time-travel
         * debugging.
         *
         * To use the debugger, install the Redux Devtools extension for either
         * Chrome or Firefox
         *
         * See: https://github.com/zalmoxisus/redux-devtools-extension
         */
    !environment.production
    ? StoreDevtoolsModule.instrument({ maxAge: 50, name: 'PAY' })
    : [],

    // NGRX
    AppStateModule,

    // Shell
    MobileBlockerComponent,
    NavigationMenuComponent,
    ProfileMenuComponent,
    ContextBarModule,
    ContextBarDirectiveModule,
    EmptyComponent,
    GoComponent,
    AllowedForAppFlavourDirective,
    AppFlavourClassDirective
  ],
  providers: [
    APP_PROVIDERS,
    ENV_PROVIDERS,
    LOTTIE_PROVIDER,
    CLIENT_CONFIG_INITIALIZER_PROVIDER,
    AppService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
